import React, { useContext, useMemo } from 'react';
import Tags from '@wix/da-shared-react/pkg/Tags';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { TagStrip } from '../../../../types/api';
import StripWrapper from '../StripWrapper';
import s from './TagsStrip.scss';

export interface Props {
  strip: TagStrip;
  isSearchPage?: boolean;
  className?: string;
}

const TagsStrip: React.FC<Props> = ({ strip, className, isSearchPage }) => {
  const isMobile = useContext(MobileContext);

  const tags = useMemo(
    () =>
      strip.tags.map(stripTag => ({ name: stripTag.tag, url: stripTag.url })),
    [strip.tags]
  );

  return (
    <StripWrapper
      strip={strip}
      className={className}
      isSearchPage={isSearchPage}
    >
      <div className={s['tag-bar-wrapper']}>
        <Tags tags={tags} isFoldable={!isMobile} className={s['tag-bar']} />
      </div>
    </StripWrapper>
  );
};
TagsStrip.displayName = 'TagsStrip';

export default TagsStrip;
